import models from 'plugins/i18n/modelTypes.de.ts'

export default {
	activityFeed: {
		title: 'Aktualisierungen',
		from: 'von',
		created: 'angelegt',
		edited: 'bearbeitet',
		field_updated: '{field} wurde von {from} auf {to} aktualisiert',
		model: { ...models },
	},
}
